import { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { api, ApiError } from '../api/client';
import type { SurveyDetail } from '../api/types';
import { EnumeratorAssignments, GroupRandomizer, RespondentAssignments } from '../components/field/Assignments';
import { FieldNav, SurveyHeader } from '../components/SurveyHeader';
import { PageLoader } from '../components/ui';
import { useI18n } from '../i18n';

/** Field tab, assignments view: enumerators, respondent visits and study groups. */
export function FieldWorkPage() {
  const { id = '' } = useParams();
  const { t } = useI18n();
  const [survey, setSurvey] = useState<SurveyDetail | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api.getSurvey(id).then(setSurvey, (e) => setError(e instanceof ApiError ? e.message : t('common.load_failed')));
  }, [id, t]);

  if (error) return <div className="banner error">{error}</div>;
  if (!survey) return <PageLoader />;
  if (!survey.permissions.includes('survey.enumerators.assign')) return <Navigate to={`/surveys/${id}/share`} replace />;

  return (
    <>
      <SurveyHeader
        id={survey.id}
        number={survey.number}
        code={survey.code}
        status={survey.status}
        permissions={survey.permissions}
        active="field"
        title={
          <h1 className="ellipsis" style={{ fontSize: 26, fontWeight: 500 }}>
            {survey.title || t('common.untitled_questionnaire')}
          </h1>
        }
      />
      <FieldNav id={survey.id} permissions={survey.permissions} active="assignments" />
      <div className="field-page">
        <EnumeratorAssignments surveyId={survey.id} />
        <RespondentAssignments surveyId={survey.id} />
        <GroupRandomizer surveyId={survey.id} />
      </div>
    </>
  );
}
